import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
// import {COURSE_LIST} from "./data";
import {
    fetchCourseDetails,
    getCourseList,
    fetchPlayersLive,
} from "./live.view.api.services";

const LiveViewContext = createContext();

export function useLiveViewContext() {
    return useContext(LiveViewContext);
}

export const LiveViewProvider = ({children}) => {
    const [state, setState] = useState({
        courseList: null,
        selectedCourse: null,
        courseData: null,
        courseLoading: false,
        liveDataLoading: false,
        playersLiveData: null,
    });

    // useEffect(() => {
        
    //     if (state.courseList === null) {
    //         getCourseList().then((res) => {
    //             console.log(res);
    //             setState({...state, courseList: res.data.data});
    //         });
    //     }
    //     if (!state.selectedCourse && state.courseList?.length) {
    //         setState((_state) => ({
    //             ...state,
    //             selectedCourse: state.courseList[0],
    //         }));
    //     }
    // }, [state.courseList]);
useEffect(() => {
    const loadInitialData = async () => {
        if (!state.courseList) {
            try {
                const res = await getCourseList();
                const courseList = res.data.data;
                const savedCourseId = localStorage.getItem("selectedLiveCourseId");
                let selectedCourse = null;

                if (savedCourseId) {
                    selectedCourse = courseList.find(c => String(c.id) === String(savedCourseId));
                }

                // If not found or not saved, default to first course
                if (!selectedCourse && courseList.length > 0) {
                    selectedCourse = courseList[0];
                }

                setState((prev) => ({
                    ...prev,
                    courseList,
                    selectedCourse,
                }));
            } catch (e) {
                console.error("Error loading course list", e);
            }
        }
    };

    loadInitialData();
}, []);

    useEffect(() => {
        fetchCourseData();
    }, [state.selectedCourse, state.courseList]);

    const fetchCourseData = useCallback(async () => {
        const courseId = state.selectedCourse?.id;
        if (!courseId) return;

        try {
            setState((_s) => ({
                ..._s,
                courseLoading: true,
            }));

            const courseData = await fetchCourseDetails(courseId);

            setState(_s => ({
                ..._s,
                courseData: courseData.data.data,
            }));


        } catch (e) {

        } finally {
            setState((_s) => ({
                ..._s,
                courseLoading: false,
            }));
        }
    }, [state]);

    return (
        <LiveViewContext.Provider
            value={{
                state,
                setState,
            }}
        >
            {children}
        </LiveViewContext.Provider>
    );
};
  